// js/feedback-page.js — публичная форма обратной связи /feedback.php.
// Phase 4.10d.1 (2026-05-29). Pattern: ip_claim.js — IIFE+guard, no inline
// handlers, CSRF из <meta name="csrf-token">, fetch same-origin + _csrf в body.
(function () {
  'use strict';

  var form = document.getElementById('feedbackForm');
  if (!form) return;

  var btn = document.getElementById('fbSubmit');
  var bodyEl = document.getElementById('fbBody');
  var success = document.getElementById('fbSuccess');
  var successMsg = document.getElementById('fbSuccessMsg');
  var csrfInput = document.getElementById('feedbackCsrf');
  var bodyError = document.getElementById('fbBodyError');

  // Подтянуть CSRF-токен из meta (генерируется header.php csrfToken()).
  if (csrfInput) {
    var meta = document.querySelector('meta[name="csrf-token"]');
    if (meta) {
      var token = meta.getAttribute('content') || '';
      if (token) csrfInput.value = token;
    }
  }

  function showBodyError(show) {
    if (!bodyError) return;
    if (show) {
      bodyError.classList.add('active');
    } else {
      bodyError.classList.remove('active');
    }
  }

  // Real-time error clearing.
  if (bodyEl) {
    bodyEl.addEventListener('input', function () { showBodyError(false); });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (btn && btn.disabled) return;

    showBodyError(false);

    var body = (bodyEl && bodyEl.value ? bodyEl.value : '').trim();
    if (body === '') {
      showBodyError(true);
      if (bodyEl) bodyEl.focus();
      return;
    }

    var subjectEl = document.getElementById('fbSubject');
    var contactEl = document.getElementById('fbContact');
    var hpEl = form.querySelector('input[name="_hp"]');

    var payload = {
      _csrf: csrfInput ? csrfInput.value : '',
      _hp: hpEl ? hpEl.value : '',
      subject: subjectEl ? (subjectEl.value || '').trim() : '',
      body: body,
      contact: contactEl ? (contactEl.value || '').trim() : ''
    };

    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Отправка...';
    }

    fetch('/api/feedback-submit.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.ok) {
          form.style.display = 'none';
          if (success) success.classList.add('active');
          if (successMsg && data.message) successMsg.textContent = data.message;
          if (window.ymGoal) window.ymGoal('feedback_submit');
        } else {
          var msg = (data && data.error) || 'Не удалось отправить отзыв. Попробуйте ещё раз.';
          if (typeof window.showToast === 'function') {
            window.showToast(msg, 'warning');
          } else {
            alert(msg);
          }
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = '<i class="fas fa-paper-plane"></i> Отправить отзыв';
          }
        }
      })
      .catch(function () {
        if (typeof window.showToast === 'function') {
          window.showToast('Ошибка отправки. Проверьте подключение и попробуйте ещё раз.', 'warning');
        } else {
          alert('Ошибка отправки. Проверьте подключение и попробуйте ещё раз.');
        }
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = '<i class="fas fa-paper-plane"></i> Отправить отзыв';
        }
      });
  });
})();
